/**
 * Heavenly Hand and Earthly Hand — winning before any discard has happened
 * anywhere in the hand. `context.isFirstTurn` carries that fact (see its doc
 * comment on `ScoringContext` — populating it from live `MahjongState` is
 * deferred to T14's `advanceMatch`, this detector only consumes it).
 *
 * The dealer's seat wind is always `'east'`, so `context.seatWind === 'east'`
 * is how "the winner is the dealer" reads from `ScoringContext` without a
 * separate "is dealer" field. Heavenly (dealer completes the opening deal
 * self-drawn) and Earthly (a non-dealer Rons the very first discard) are
 * mutually exclusive by construction — `selfDrawn` can't be both, so no
 * suppression logic is needed, unlike the Half/Full Flush pairing.
 *
 * `'limit'`-kind patterns short-circuit the whole hand to a fixed cap in
 * `scoring/ScoreCalculator.ts` (T12) — `value` here is NOT load-bearing for
 * that point math, it's purely a display label. `88` is the traditional
 * number these two patterns are commonly cited at, same tier as the other
 * limit hands in this batch.
 */

import type { MatchedPattern, ScoringContext } from '../types.js';

const HEAVENLY_EARTHLY_DISPLAY_VALUE = 88;

export function matchHeavenlyHand(context: ScoringContext): MatchedPattern | null {
  if (!context.selfDrawn || !context.isFirstTurn || context.seatWind !== 'east') return null;
  return { name: 'heavenlyHand', kind: 'limit', value: HEAVENLY_EARTHLY_DISPLAY_VALUE };
}

export function matchEarthlyHand(context: ScoringContext): MatchedPattern | null {
  if (context.selfDrawn || !context.isFirstTurn || context.seatWind === 'east') return null;
  return { name: 'earthlyHand', kind: 'limit', value: HEAVENLY_EARTHLY_DISPLAY_VALUE };
}
